var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{attrs:{"rounded":_vm.rounded,"variant":_vm.variant,"size":_vm.size,"icon":_vm.loading ? 'three-dots' : _vm.icon,"src":String(_vm.imageResource) || ''}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }